import React, { useContext, useEffect, useRef, useState } from "react";

import { Box, Dialog, Slide } from "@mui/material";

import { useToast } from "../context/ToastContext";

import UpdateProfileDialog from "./UpdateProfile/UpdateProfileDialog";


import Sidebar from "./LayoutComponents/Sidebar";
import Header, { HEADER_HEIGHT } from "./LayoutComponents/Header";
import { viewportContext } from "../context/ViewportContext";
import { useLocation } from "react-router";
import { tokens } from "../theme/tokens";

export const DRAWER_WIDTH = "16vw";
export const DRAWER_WIDTH_COLLAPSED = "6vw";

interface LayoutProps {
  children: (drawerOpen: boolean) => React.ReactNode; // Change to function
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [profileDialogOpen, setProfileDialogOpen] = useState(false);

  const [drawerOpen, setDrawerOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  // const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { tallScreen } = useContext(viewportContext) as {
    tallScreen?: boolean;
  };
  const { showToast } = useToast();

  const location = useLocation();
  const [showContent, setShowContent] = useState(true);
  const prevMainRoute = useRef(location.pathname.split("/")[2]);
  const isInitialMount = useRef(true);

  useEffect(() => {
    const currentRoute = location.pathname.split("/")[2];

    // Skip animation on initial mount
    if (isInitialMount.current) {
      isInitialMount.current = false;
      prevMainRoute.current = currentRoute;
      return;
    }

    if (prevMainRoute.current !== currentRoute) {
      setShowContent(false);
      const timer = setTimeout(() => setShowContent(true), 50);
      prevMainRoute.current = currentRoute;
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (localStorage.getItem("loginSuccess") === "true") {
      showToast("Login Successful", "success");
      localStorage.setItem("loginSuccess", "false");
    }
  }, [showToast]);

  const handleDrawerToggle = () => {
    if (tallScreen) {
      setMobileOpen(!mobileOpen);
    } else {
      setDrawerOpen(!drawerOpen);
    }
  };

  const handleSettingsClick = () => {
    setProfileDialogOpen(true);
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: tokens.color.surface.sunken,
      }}
    >
      <Header
        handleDrawerToggle={handleDrawerToggle}
        handleSettingsClick={handleSettingsClick}
      />

      <Sidebar
        drawerOpen={drawerOpen}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        handleDrawerToggle={handleDrawerToggle}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          marginTop: HEADER_HEIGHT,
          height: `calc(100vh - ${HEADER_HEIGHT})`,
          overflow: "hidden",
          backgroundColor: tokens.color.surface.default,
          borderLeft: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
        }}
      >
        <Slide
          direction="up"
          in={showContent}
          timeout={{ enter: 500, exit: 0 }}
          mountOnEnter
          unmountOnExit
        >
          <Box sx={{ height: "100%", overflowY: "auto", scrollbarGutter: "stable" }}>
            {children}
          </Box>
        </Slide>
      </Box>

      <Dialog
        open={profileDialogOpen}
        onClose={() => setProfileDialogOpen(false)}
        fullWidth
        PaperProps={{ sx: { p: 2, width: "50vw", maxWidth: "50vw" } }}
      >
        <UpdateProfileDialog
          setProfileDialogClose={() => setProfileDialogOpen(false)}
        />
      </Dialog>
    </Box>
  );
};

export default Layout;
